import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const ProfileAvatarFragment = graphql(
  `
    fragment ProfileAvatar on Profile {
      address
      imageUrl
    }
  `,
  [AccountLockupFragment],
)
